<section class="toggle-form" [ngClass]="{ active: isSkillSliderOpen }">
	<div class="formwrap">
		<div *ngIf="errorMessages.length > 0">
			<p-messages severity="error">
				<ng-template pTemplate>
					<span class="p-message-icon pi pi-times-circle"></span>
					<span class="p-ml-2"
						>{{errorHeaderMessage}}</span
					>
					<ul>
						<li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
					</ul>
				</ng-template>
			</p-messages>
		</div>
		<div>
			<p-button
				appPreventDoubleClick
				styleClass="p-button-text"
				id="skillSliderCloseButton"
				type="button"
				label="Close"
				(debounceClick)="closeSlider()"
			></p-button>
		</div>
		<div class="general-container">
			<p-tabView [(activeIndex)]="activeTab">
				<p-tabPanel header="General">
					<div class="content">
						<div class="general-tab">
							<form [formGroup]="skillForm">
								<div class="fields-row">
									<div class="field field-required">
										<bpt-text-input
											label="Name"
											id="skillName"
											formControlName="name"
											[ngClass]="{ 'error-highlight': mandatoryFields.name }"
											[required]="true"
										></bpt-text-input>
									</div>
									<div class="field field-required">
										<bpt-dropdown
											label="eQMS Scope(s)"
											[options]="eQMSScopesList"
											[editable]="false"
											formControlName="eqmsScopes"
											id="skillScope"
											[showClear]="true"
											[showFilter]="true"
											[valueField]="valueField"
											[labelField]="labelField"
											[multiSelect]="true"
											[required]="true"
											[ngClass]="{ 'error-highlight': mandatoryFields.eQMSScopes }"
										>
										</bpt-dropdown>
									</div>
								</div>
								<div class="fields-row">
									<div class="field">
										<bpt-text-input
											label="Description"
											id="skillDescription"
											formControlName="description"
											[multiLine]="true"
										></bpt-text-input>
									</div>
								</div>
								<div class="fields-row">
									<div class="field">
										<bpt-text-input
											label="Training Criteria"
											id="skillTrainingCriteria"
											formControlName="trainingCriteria"
											[multiLine]="true"
										></bpt-text-input>
									</div>
								</div>
								<div class="fields-row">
									<div class="field">
										<bpt-numeric-input
											label="Validity Period"
											id="skillValidityPeriodRange"
											formControlName="validityPeriodRange"
											[showButtons]="true"
											[allowKeyboardIncrement]="true"
										></bpt-numeric-input>
									</div>
									<div class="field">
										<div class="grid">
											<div class="col m-0">
												<p-radioButton
													class="radioButton"
													name="validityPeriodInterval"
													inputId="skillValidityPeriodIntervalDays"
													[value]="0"
													label="Day(s)"
													formControlName="validityPeriodInterval"
													[required]="isValidityPeriodRangeEntered"
												></p-radioButton>
											</div>
											<div class="col m-0">
												<p-radioButton
													class="radioButton"
													name="validityPeriodInterval"
													inputId="skillValidityPeriodIntervalMonths"
													[value]="1"
													label="Month(s)"
													formControlName="validityPeriodInterval"
													[required]="isValidityPeriodRangeEntered"
												></p-radioButton>
											</div>
											<div class="col m-0">
												<p-radioButton
													class="radioButton"
													name="validityPeriodInterval"
													inputId="skillValidityPeriodIntervalYears"
													[value]="2"
													label="Year(s)"
													formControlName="validityPeriodInterval"
													[required]="isValidityPeriodRangeEntered"
												></p-radioButton>
											</div>
										</div>
									</div>
								</div>
								<div class="fields-row">
									<div class="field checkbox-field">
										<p-checkbox
											p-label-active
											label="Verification Required?"
											[binary]="true"
											formControlName="verificationRequired"
										>
										</p-checkbox>
									</div>
								</div>
									<div class="fields-row">
									<div class="field checkbox-field">
										<p-checkbox
											p-label-active
											label="Acknowledgement Required?"
											[binary]="true"
											formControlName="acknowledgementRequired"
										>
										</p-checkbox>
									</div>
									</div>
									<div class="fields-row" *ngIf="isEditMode">
										<div class="field checkbox-field">
											<p-checkbox
												p-label-active
												label="Is Active?"
												tooltipPosition="top"
												[binary]="true"
												formControlName="isActive"
											>
											</p-checkbox>
											 <i
                class="fa fa-info-circle ml-2 info-icon-color"
                aria-hidden="true"
                pTooltip="{{ isActiveCheckBoxToolTip }}"
              ></i>
										</div>
									</div>
							</form>
							<div class="flex justify-content-end mt-2">
								<p-button
									appPreventDoubleClick
										label="Save"
									type="button"
									id="skillSaveButton"
									styleClass="bpt-button-compact"
									(debounceClick)="saveSkill()"
								></p-button>
							</div>
						</div>
					</div>
				</p-tabPanel>
			</p-tabView>
		</div>
	</div>
</section>
